import { render, staticRenderFns } from "./subsidyRankDetails.vue?vue&type=template&id=64c528a6&scoped=true&"
import script from "./subsidyRankDetails.vue?vue&type=script&lang=js&"
export * from "./subsidyRankDetails.vue?vue&type=script&lang=js&"
import style0 from "./subsidyRankDetails.vue?vue&type=style&index=0&id=64c528a6&prod&scoped=true&lang=css&"
import style1 from "./subsidyRankDetails.vue?vue&type=style&index=1&id=64c528a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c528a6",
  null
  
)

export default component.exports